module.exports = __webpack_public_path__ + "img/15.aec38dd9.png";